<template>
  <button v-show="visible" class="back-to-top" type="button" @click="scrollToTop" aria-label="Back to top">
    ↑
  </button>
</template>

<script>
export default {
  name: 'BackToTop',
  data: function () {
    return {
      visible: false
    };
  },
  mounted: function () {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll: function () {
      this.visible = window.scrollY > 420;
    },
    scrollToTop: function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
.back-to-top {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 52px;
  height: 52px;
  border: 0;
  border-radius: 50%;
  background: var(--color-accent-deep);
  color: #fff;
  box-shadow: var(--shadow-soft);
  cursor: pointer;
  z-index: 20;
}
</style>
